import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { trackPhoneClick, trackEmailClick, trackRequestQuoteClick } from "@/utils/analytics";

function App() {
  useEffect(() => {
    const isQuoteCTAText = (text: string): boolean => {
      const lower = text.toLowerCase();
      return lower.includes('request quote') ||
        lower.includes('request a quote') ||
        lower.includes('contact us') ||
        lower.includes('get a quote');
    };

    const handleClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest('a');
      if (!anchor) return;

      const href = anchor.getAttribute('href');
      if (!href) return;

      if (href.startsWith('tel:')) {
        trackPhoneClick();
        return;
      }

      if (href.startsWith('mailto:')) {
        trackEmailClick();
        return;
      }

      if (href.startsWith('/contact')) {
        const text = anchor.textContent?.trim() || '';
        if (isQuoteCTAText(text)) {
          trackRequestQuoteClick(text.slice(0, 50));
        }
      }
    };

    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, []);

  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;